import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { SportOffer, EventOffer as EVentOfferType } from "@gp/offer";
import {
	EventContext,
	OfferOptionsContext,
	SportOfferContext,
} from "@gp/components";
import { EventOffer } from "..";
import { useIsAdditionalOfferVisible } from "@utils/offer";
import useGetOffer from "@state/hooks/offer/useGetOffer";
import useGetIsEventFeatured from "@state/hooks/offer/useGetIsEventFeatured";

import { MainOffer } from ".";

export const Event = observer(function Event(props: {
	isAlternate?: boolean;
	displaySport?: boolean;
	showSecondaryOffer?: boolean;
	hasSecondaryOffer?: boolean;
	noSecondaryOffer?: boolean;
	secondaryOfferCount?: number;
	offerCategory?: string;
}) {
	//#region offer

	const { t } = useTranslation();
	const sport = useContext(SportOfferContext) as SportOffer;
	const event = useContext(EventContext) as EVentOfferType;
	const options = useContext(OfferOptionsContext);

	const { mainColumns, secondaryColumns, additionalOfferCount } = useGetOffer(
		props,
		sport,
		event
	);

	const isAdditionalOfferVisible = useIsAdditionalOfferVisible();
	const isEventFeatured = useGetIsEventFeatured();

	//#endregion offer

	return (
		<>
			<MainOffer
				secondaryColumns={secondaryColumns}
				mainColumns={mainColumns}
				additionalOfferCount={additionalOfferCount}
				isAlternate={props.isAlternate}
				displaySport={props.displaySport}
				offerCategory={props.offerCategory}
			/>

			{/* SECONDARY OFFER */}
			{props.showSecondaryOffer && !secondaryColumns.isEmpty ? (
				<div
					className={classNames(
						"offer__body__row offer__ht offer--sports__ht",
						{
							"is-selected": isEventFeatured,
							odd: !props.isAlternate,
							"is-top-event":
								/* @ts-expect-error */
								!options?.shouldHideTopTag && event.isTopEvent,
						}
					)}
				>
					<div
						className={classNames(
							"offer__body__data offer__ht__row offer--sports__ht__row",
							{
								"is-collapsed": isAdditionalOfferVisible,
								"is-selected": isEventFeatured,
							}
						)}
					>
						<div className="offer__ht__inner offer--sports__ht__inner">
							<span className="offer__ht__title">
								{t("LIVE.FIRST_HALF_TIME")}
							</span>
						</div>

						<EventOffer columns={secondaryColumns} />
					</div>
				</div>
			) : null}
		</>
	);
});
